<template>
  <Container :keyword="filter" :action="() => {}">
    <PageHeader :title="$options.name">
      <ButtonFilter :action="() => _trigger()" />
      <ButtonPdf :loading="is_print" :action="() => _exportPDF()" />
      <ButtonExcel :action="() => _exportExcel()" />
    </PageHeader>
    <DataTable
      :skeleton="filter.requested"
      :noData="!filter.requested && response.data.invoice.length == 0"
      :show="!filter.requested && response.data.invoice.length > 0"
      :filter="filter"
      :action="() => _get()"
      :defaultFormat="style_table"
    >
      <thead>
        <tr>
          <th colspan="3" rowspan="2">Code</th>
          <th rowspan="2">Level harga</th>
          <th colspan="2">Qty</th>
          <th colspan="3">Pengembalian</th>
        </tr>
        <tr>
          <th
            v-for="(cop, i) in ['dus', 'pcs', '1', '2', '3']"
            :key="i"
            v-html="cop"
          />
        </tr>
      </thead>
      <tbody>
        <template v-for="(row, brand) in response.data.detail">
          <tr :key="brand">
            <td colspan="9"><strong>GROUP : </strong> {{ brand }}</td>
          </tr>
          <template v-for="(val, j) in row">
            <tr :key="brand + j">
              <td>{{ val.item_code }}</td>
              <td>{{ val.kode_barang }}</td>
              <td>{{ val.nama_barang }}</td>
              <td class="text-center">{{ val.tipe_harga }}</td>
              <td class="text-center">{{ val.sum_qty }}</td>
              <td class="text-center">{{ val.sum_qty_pcs }}</td>
              <td colspan="3" />
            </tr>
          </template>
          <tr :key="'total' + brand" class="total">
            <td colspan="4" class="text-left">
              <strong>SUBTOTAL : </strong>
            </td>
            <td>{{ response.data.subtotal[brand].sum_qty }}</td>
            <td>{{ response.data.subtotal[brand].sum_qty_pcs }}</td>
            <td colspan="3" />
          </tr>
        </template>
        <tr>
          <td colspan="2"><strong>No.DO </strong></td>
          <td colspan="10">
            <div class="row">
              <div
                class="col"
                style="min-width: 150px"
                v-for="(inv, i) in response.data.invoice"
                v-html="inv"
                :key="i"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2"><strong>BANYAK DO </strong></td>
          <td colspan="10">
            {{ response.data.invoice.length }}
          </td>
        </tr>
      </tbody>
    </DataTable>
    <FormFilter />
  </Container>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "RekapitulasiDeliveryOrder",
  components: { FormFilter },
  data() {
    return {
      is_print: false,
      style_table: "table table-bordered card-table",
    };
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState("rekapitulasi_do", {
      filter: (state) => state.filter,
      response: (state) => state.response,
    }),
  },
  mixins: [helper],

  methods: {
    ...mapActions("rekapitulasi_do", ["triggerModal", "getRekapitulasiDo"]),
    _trigger() {
      return this.triggerModal("filter");
    },
    _get() {
      if (this.$route.name == "rekapitulasiDODriver") {
        this.filter.id_salesman = [];
      } else {
        this.filter.id_driver = [];
      }
      this.getRekapitulasiDo();
    },
    async _exportPDF() {
      if (this.is_print) {
        this.toast("Mohon menunggu...");
      } else {
        this.is_print = true;
        let location =
          this.$route.name == "rekapitulasiDODriver" ? "inventory" : "sales";
        let data = this.response.data;
        if (localStorage.getItem(location) === null) {
          localStorage.rekapitulasiDO = JSON.stringify(data);
        } else {
          localStorage.removeItem(location);
          localStorage.rekapitulasiDO = JSON.stringify(data);
        }
        localStorage.rekapitulasiDO = JSON.stringify(data);

        if (location == "inventory") {
          let formData = {
            depo: data.depo,
            start_date: data.start_date,
            end_date: data.end_date,
            driver: data.driver,
            salesman: data.salesman,
            qr_url: data.qr_url,
          }
          
          await this.axios.post('report/rekapitulasi_do_notification', formData)
            .then(() => {
              this.toast("Notifikasi telah dikirimkan ke channel telegram")
            })
            .catch((err) => {
              this.onError(err);
            });
        }

        window.open(
          window.location.origin +
            "/dashboard/" +
            location +
            "/rekapitulasi-do/print",
          "_blank"
        );
        this.is_print = false;
      }
    },
    _exportExcel(){
      const penjualan = this.response.data.penjualan 
      let data_excel = []
      penjualan.forEach((data, index) => {
        data_excel.push({
          'NO': index + 1,
          'NAMA_DRIVER': data.nama_driver,
          'INVOICE_NO': data.no_invoice,
          'CUSTOMER_NAME': data.nama_toko,
          'ALAMAT': data.alamat,
          'DISTRICT': data.nama_kecamatan,
          'QTY_CTN': data.sum_qty,
          'QTY_PCS': data.sum_qty_pcs,
          'ENTITAS': data.kode_perusahaan,
        })
      })
      this.createExcel({
        data: data_excel,
        filename: "rekapitulasi-delivery-order-"+this.filter.start_date+"-"+this.filter.end_date,
      });
    }
  },
  mounted() {
    // this._get();
  },
};
</script>
<style scoped>
.table thead th,
.markdown > table thead th {
  vertical-align: middle;
  text-align: center;
}
.total {
  background-color: #4d5e78;
  color: white;
}
.total td {
  text-align: center;
}
tr td {
  text-transform: uppercase;
}
</style>
